import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Pagination from 'components/Pagination';
import Select from 'components/Select';
import Modal from 'components/Modal';
import { Spinner } from 'triider-components';
import { Creators as DashCreators } from 'store/ducks/dash';
import { colors } from 'stylesheets';
import { selectInvoices } from 'utils/select';
import Row from '../Row';

import {
  List,
  Buttons,
  SelectStyled,
  Footer,
  Loader,
  Content,
  Text,
  Label,
} from './styles';

const Invoices = ({
  invoice, setInvoice, _getInvoices, invoices, _position, total, loadingVisible,
}) => {
  const [offset, setOffset] = useState(false);
  const [position, setPosition] = useState(0);
  const [positionFilter, setPositionFilter] = useState(0);
  const [limit, setLimit] = useState(false);
  const [interval, sInterval] = useState(false);
  const [filter, setFilter] = useState(false);

  const listInvoices = () => {
    _getInvoices({
      offset: offset || 0,
      limit: limit || 5,
      interval: interval || 1,
      filter: filter || null,
      position,
      positionFilter,
    });
  };

  useEffect(() => {
    listInvoices();
  }, [invoice, offset, interval, positionFilter]);

  const handleInvoice = () => {
    setInvoice(!invoice);
  };

  const handleInterval = (e) => {
    const { value } = e.target;
    sInterval(selectInvoices.value[value]);
    setPosition(value);
  };

  return (
    <Modal
      ticket
      closebutton
      modallist={invoice.toString()}
      isOpen={invoice}
      borderbottomheader="none"
      paddingheader="40px"
      textalingheader="initial"
      backgroundcolor={colors.blueLight}
      backgroundclip="padding-box"
      padding="0px 40px 40px;"
      width="1000px"
      title="NOTAS FISCAIS"
      disabled={false}
      toggle={handleInvoice}
    >
      {loadingVisible ? (
        <Loader>
          <Spinner size="larger" />
        </Loader>
      ) : (
        <Content>
          <Buttons invoices={invoices}>
            <SelectStyled>
              <Label>Data:</Label>
              <Select
                value={_position || 1}
                options={selectInvoices.name}
                onChange={handleInterval}
              />
            </SelectStyled>
          </Buttons>
          {!total && (
            <Text>Sem Notas Fiscais :(</Text>
          )}
          <List>
            {invoices
              && invoices.map((i, key) => (<Row key={key} invoice={i} />))
            }
          </List>
          {!!invoices.length && (
          <Footer>
            <Pagination
              total={total}
              listMaxLength={5}
              offset={offset}
              setOffset={pageOffset => setOffset(pageOffset)}
            />
          </Footer>
          )}
        </Content>
      )}
    </Modal>
  );
};

const mapStateToProps = state => ({
  invoices: state.dash.invoices.list,
  total: state.dash.invoices.total,
  _position: state.dash.invoices.position,
  loadingVisible: state.ui.loaders.includes('INVOICE_LIST'),
});

const mapDispatchToProps = {
  _getInvoices: DashCreators.getInvoiceDashRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Invoices);
